import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';

export const SectionHeader = ( props ) => {
    // Construct the classes to use for the component root.
    const rootClasses = classNames(
        'section-header',
        { [ props.className ]: Boolean( props.className ) },
    );

    return (
        <h2 className={ rootClasses }>
            <span>
                { props.children }
            </span>
        </h2>
    );
};

SectionHeader.propTypes = {
    className: PropTypes.string
};
